import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useRef, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
import Text from "noood/comp/text/Text";
import Row from "noood/comp/ui/containers/flex-boxes/Row";
import Spacer from "noood/comp/ui/spacer/Spacer";
import { ArrayUtil } from "noood/util/array/ArrayUtil";
import { color } from "noood/util/ui/color";
export default function OptionPickerPopover(props) {
  var _props$list, _props$list2, _props$list3;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    currentHighlight = _useState4[0],
    setCurrentHighlight = _useState4[1];
  var floaterRef = useRef();
  var filterField = useRef();
  var __paint = function __paint(resetOpacity) {
    var _props$sender;
    console.log("painting...");
    var floater = floaterRef.current;
    var anchor = (_props$sender = props.sender) === null || _props$sender === void 0 ? void 0 : _props$sender.getBoundingClientRect();
    if (floater) {
      var _props$optionsContain, _filterField$current;
      if (resetOpacity) {
        floater.style.opacity = "0";
      }
      floater.showPopover();
      var floaterBox = floater.getBoundingClientRect();
      floater.style.left = "".concat(anchor.x, "px");
      floater.style.width = "".concat((_props$optionsContain = props.optionsContainerMinimumWidth) !== null && _props$optionsContain !== void 0 ? _props$optionsContain : anchor.width, "px");
      if (anchor.bottom + floaterBox.height > window.innerHeight - 10) {
        // show above the anchor
        floater.style.top = "".concat(anchor.top - floaterBox.height - 1, "px");
        floater.style.borderBottomLeftRadius = "0";
        floater.style.borderBottomRightRadius = "0";
        floater.style.borderTopLeftRadius = "var(--roundness)";
        floater.style.borderTopRightRadius = "var(--roundness)";
      } else {
        floater.style.top = "".concat(anchor.bottom + 1, "px");
        floater.style.borderBottomLeftRadius = "var(--roundness)";
        floater.style.borderBottomRightRadius = "var(--roundness)";
        floater.style.borderTopLeftRadius = "0";
        floater.style.borderTopRightRadius = "0";
      }
      setTimeout(function () {
        floater.style.opacity = "1";
      }, 10);
      floater.addEventListener('beforetoggle', function (e) {
        if (e.newState === 'closed') {
          var _props$__onClose;
          (_props$__onClose = props.__onClose) === null || _props$__onClose === void 0 || _props$__onClose.call(props);
        }
      });
      filterField === null || filterField === void 0 || (_filterField$current = filterField.current) === null || _filterField$current === void 0 || _filterField$current.focus();
    }
  };
  useEffect(function () {
    __paint(true);
  }, []);
  useEffect(function () {
    __paint(false);
  }, [filter]);
  var filteredOption = (_props$list = props.list) === null || _props$list === void 0 ? void 0 : _props$list.filter(function (opt) {
    if ((filter === null || filter === void 0 ? void 0 : filter.trim().length) > 0) {
      var _opt$code;
      if ((_opt$code = opt.code) !== null && _opt$code !== void 0 && (_opt$code = _opt$code.toLowerCase()) !== null && _opt$code !== void 0 && _opt$code.match(filter.toLowerCase())) {
        return true;
      } else return false;
    } else return true;
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    popover: "",
    ref: floaterRef
  }, {
    className: "OptionPickerPopover__ui.popover evh3736h ev1vqne9w ev1717udv ev1ghz6dp evlyjyp1 ev11ycvst ev10l6tqk ev1hkcv85 ev1odjw0f ev36ibnl evzap5uf"
  }), ((_props$list2 = props.list) === null || _props$list2 === void 0 ? void 0 : _props$list2.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      borderBottom: "1px solid var(--shade-20)",
      backgroundColor: "var(--shade-10)",
      alignItems: "stretch"
    }
  }, (props.canFilter === void 0 || props.canFilter) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: "4px"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "search",
    color: color.appendAlpha(color.extractCSSValue('--text-color'), 50)
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("input", _extends({}, {
    className: "OptionPickerPopover__ui.filter ev1whlmpv ev1jvydc1 evh8yej3 ev1wty727 ev1a2a7pz ev5ea3kt evjbqb8w ev1mac9bf"
  }, {
    placeholder: "Search options...",
    ref: filterField,
    value: filter,
    onChange: function onChange(e) {
      setFilter(e.target.value);
    },
    onBlur: function onBlur(e) {
      // props.__onClose?.();
      setCurrentHighlight(undefined);
    },
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      var nextHighlight = (currentHighlight !== null && currentHighlight !== void 0 ? currentHighlight : -1) + 1;
      if (nextHighlight > filteredOption.length - 1) {
        nextHighlight = 0;
      }
      if (e.code === "ArrowDown") {
        setCurrentHighlight(nextHighlight);
      }
      if (e.code === "ArrowUp") {}
      if (e.code === "Enter") {
        var _props$__pick;
        (_props$__pick = props.__pick) === null || _props$__pick === void 0 || _props$__pick.call(props, (filteredOption === null || filteredOption === void 0 ? void 0 : filteredOption.length) === 1 ? filteredOption[0] : filteredOption[nextHighlight - 1]);
        setCurrentHighlight(undefined);
      }
      if (e.code === "Tab") {}
    }
  }))))), filteredOption.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "OptionPickerPopover__ui.no_filter_match evlbmfb8 ev7ywyr2 ev78zum5 evdt5ytf ev6s0dn4 evl56j7k"
  }, /*#__PURE__*/React.createElement(Row, {
    gap: 5
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, "No option matching:"), /*#__PURE__*/React.createElement(Text, null, filter)), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 10
  })), filteredOption.map(function (opt, idx) {
    var _props$multipleOption, _props$currentChosenO, _props$currentChosenO2, _props$currentChosenO3;
    // is found in multiple array?
    var isInMultiple = props.multiple && ((_props$multipleOption = props.multipleOptionsSelected) === null || _props$multipleOption === void 0 ? void 0 : _props$multipleOption.length) > 0 && ArrayUtil.array_find_index(props.multipleOptionsSelected, 'value', opt.value) > -1;
    var isActive = ((_props$currentChosenO = props.currentChosenOption) === null || _props$currentChosenO === void 0 ? void 0 : _props$currentChosenO.value) === opt.value;
    return /*#__PURE__*/React.createElement("div", _extends({
      key: "opt-picker-opt-".concat(idx)
    }, stylex.props(ui.option, (((_props$currentChosenO2 = props.currentChosenOption) === null || _props$currentChosenO2 === void 0 ? void 0 : _props$currentChosenO2.value) === opt.value || isInMultiple) && ui.active_option, idx === currentHighlight && ui.focus_highlight), {
      onClick: function onClick() {
        var _props$__pick2;
        (_props$__pick2 = props.__pick) === null || _props$__pick2 === void 0 || _props$__pick2.call(props, opt);
      }
    }), opt.icon && /*#__PURE__*/React.createElement(Icon, {
      icon: opt.icon,
      color: color.appendAlpha(color.extractCSSValue(isActive ? '--text-on-accent' : '--text-color'), 50)
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(Text, {
      color: ((_props$currentChosenO3 = props.currentChosenOption) === null || _props$currentChosenO3 === void 0 ? void 0 : _props$currentChosenO3.value) === opt.value || isInMultiple ? 'var(--text-on-accent)' : 'var(--text-color)'
    }, opt.code)),
    // check if this is in multiple
    isInMultiple && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: "check"
    })));
  })), (props.list === void 0 || ((_props$list3 = props.list) === null || _props$list3 === void 0 ? void 0 : _props$list3.length) === 0) && /*#__PURE__*/React.createElement("div", {
    className: "OptionPickerPopover__ui.no_filter_match evlbmfb8 ev7ywyr2 ev78zum5 evdt5ytf ev6s0dn4 evl56j7k"
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, "No available options")));
}
OptionPickerPopover.propTypes = {
  // proptypes
};

// @ts-ignore
_inject(".evh3736h{inset:unset}", 1000);
_inject(".ev1vqne9w{border:1px solid light-dark(#aaa,#727272)}", 1000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".evlyjyp1{box-shadow:0 15px 50px rgba(0,0,0,.3)}", 3000);
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".ev10l6tqk{position:absolute}", 3000);
_inject(".ev1hkcv85{max-height:200px}", 4000);
_inject(".ev1odjw0f{overflow-y:auto}", 4000);
_inject(".ev36ibnl{border-bottom-left-radius:var(--roundness)}", 4000);
_inject(".evzap5uf{border-bottom-right-radius:var(--roundness)}", 4000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev1nejdyq{gap:5px}", 2000);
_inject(".ev1m3ybwc{padding:4px 5px}", 1000);
_inject(".evz7ivw7{border-bottom:1px solid var(--shade-10)}", 2000);
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
_inject(".evi51yt4:last-of-type{border-bottom:0}", 2055);
_inject(".ev1whlmpv{padding:4px 6px}", 1000);
_inject(".ev1jvydc1{font-size:15px}", 3000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev1wty727{border:0}", 1000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".ev5ea3kt{color:var(--shade-70)}", 3000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".ev1mac9bf::placeholder{color:var(--shade-30)}", 8000);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
_inject(".evlbmfb8{padding:20px 5px}", 1000);
_inject(".ev7ywyr2{min-height:50px}", 4000);
_inject(".evdt5ytf{flex-direction:column}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
var ui = {
  option: {
    "OptionPickerPopover__ui.option": "OptionPickerPopover__ui.option",
    display: "ev78zum5",
    cursor: "ev1ypdohk",
    gap: "ev1nejdyq",
    rowGap: null,
    columnGap: null,
    padding: "ev1m3ybwc",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderBottom: "evz7ivw7",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "ev1y7ric0 ev3dtjww",
    ":last-of-type_borderBottom": "evi51yt4",
    ":last-of-type_borderBottomWidth": null,
    ":last-of-type_borderBottomStyle": null,
    ":last-of-type_borderBottomColor": null,
    $$css: true
  },
  active_option: {
    "OptionPickerPopover__ui.active_option": "OptionPickerPopover__ui.active_option",
    backgroundColor: "evwnonoy",
    color: "ev1tzx33q",
    $$css: true
  },
  focus_highlight: {
    "OptionPickerPopover__ui.focus_highlight": "OptionPickerPopover__ui.focus_highlight",
    backgroundColor: "evwnonoy",
    color: "ev1tzx33q",
    $$css: true
  }
};